import React from "react";
import { useTheme } from "styled-components";
import { SliceComponentProps } from "@prismicio/react";

import {
  SingleUserHeartUser,
  ClockStopwatch,
  SettingFilter,
  EmployeesCheckmark,
  MobileDeviceIphoneMonitor,
} from "@ui/Assets/MyIcons";
import * as Grid from "@ui/Atoms/Grid";
import { Text } from "@ui/Atoms/Text";
import { MyIconProps } from "@ui/Assets/MyIcons/MyIcons";

import { PrismicLandingPageV2DataBodyBenefitslist } from "@www/graphql-types";

import { ScrollZone } from "../../Components";

import * as Styled from "./BenefitsList.styled";

const icons: { [key in string]: React.ComponentType<MyIconProps> } = {
  ClockStopwatch,
  SettingFilter,
  SingleUserHeartUser,
  EmployeesCheckmark,
  MobileDeviceIphoneMonitor,
};

export const BenefitsList = (
  props: SliceComponentProps<PrismicLandingPageV2DataBodyBenefitslist>,
) => {
  const theme = useTheme();

  const { primary, items } = props.slice;
  const isDarkModeEnabled = !!primary.benefitslist_color_mode;

  return (
    <Styled.Root
      as="section"
      widthVariant="full"
      style={{
        backgroundColor: primary.benefitslist_background_color || "transparent",
      }}
    >
      <Grid.Container>
        <Text
          as="h2"
          $style="semibold_32"
          $color={isDarkModeEnabled ? "white" : "grey800"}
        >
          {primary.benefitslist_title.text}
        </Text>
      </Grid.Container>

      <ScrollZone>
        {items.map((benefit, index) => {
          const iconName = benefit.benefit_icon;
          const Icon = (iconName && icons[iconName]) || null;

          return (
            <Styled.Benefit key={index}>
              {Icon && (
                <Icon
                  height={theme.icons.sizes.base_x4}
                  width={theme.icons.sizes.base_x4}
                />
              )}
              <Styled.TextWrapper>
                <Text
                  as="h3"
                  $color={isDarkModeEnabled ? "white" : "grey800"}
                  $style="bold_24"
                >
                  {benefit.benefit_title.text}
                </Text>
                <Text
                  as="p"
                  $color={isDarkModeEnabled ? "white" : "grey400"}
                  $style={{ default: "regular_16", largeMobile: "regular_18" }}
                >
                  {benefit.benefit_subtitle.text}
                </Text>
              </Styled.TextWrapper>
            </Styled.Benefit>
          );
        })}
      </ScrollZone>
    </Styled.Root>
  );
};
